import Vue from 'vue';
import moment from 'moment';
export default {
    install(Vue, options) {
        Vue.filter('formatDate', function (value, format) {
            if (value) {
                return moment(String(value)).format(format || 'DD MMM [at] hh:mm A');
            }
        });
        Vue.filter('formatDate2', function (value) {
            if (value) {
                return moment(String(value)).format('DD MMM YYYY');
            }
        });
        Vue.filter('formatDate3', function (value) {
            if (value != 'Today') {
                return moment(String(value)).format('ddd');
            }else{
                return 'Today'
            }
        });
        Vue.filter('showDateIn', function (value, unit) {
            if (value) {
                unit = unit || 'days';
                return Math.abs(moment().diff(value, unit, false));
            }
        });
        Vue.filter('age', function (value) {
            if (value) {
                return moment().diff(value, 'years', false);
            }
        });
        Vue.filter('timeElaped', function (date) {
            if (date) {
                var days = moment().diff(date, 'days');
                if(days > 1){
                    return moment(String(date)).format('DD MMM YYYY');
                }else{
                    return moment(date).fromNow();
                }
            }
        });
    }};
